<microempresario-header></microempresario-header>

<section id="landing_aceptacion-credito" class="landing-aceptacion">
  <div class="landing-aceptacion__inner">
    <article class="landing-aceptacion__card">
      <div class="landing-aceptacion__content">
        <h1 class="landing-aceptacion__title">Felicitaciones</h1>
        <h2 class="landing-aceptacion__subtitle">¡Has aceptado una oferta de crédito!</h2>
        <p class="landing-aceptacion__text">
          Pronto te contactará un asesor de
          <strong>{{ aliadoFinanciero }}</strong>.
        </p>

        @if (urlLanding) {
          <p class="landing-aceptacion__link-wrap">
            Puedes visitar al aliado financiero siguiendo
            <button
              type="button"
              class="landing-aceptacion__link"
              title="Abrir enlace"
              (click)="_modal.enlaceModal(urlLanding)"
            >
              este enlace
            </button>.
          </p>
        }

        <a
          routerLink="/microempresario/home"
          class="landing-aceptacion__cta"
          id="btn-ofertas-landing-finalizar"
          (click)="trackFinalizar()"
        >
          Finalizar
        </a>
      </div>

      <div class="landing-aceptacion__media">
        <img
          src="assets/img/aceptacionSolicitud.jpg"
          alt=""
          class="landing-aceptacion__img"
        />
      </div>
    </article>
  </div>

  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
</section>

<div class="landing-aceptacion__chrome">
  <app-footer-public variant="compact"></app-footer-public>
  <app-home-site-footer></app-home-site-footer>
</div>
